import { render, staticRenderFns } from "./config-US.vue?vue&type=template&id=ec4b4534"
import script from "./config-US.vue?vue&type=script&lang=js"
export * from "./config-US.vue?vue&type=script&lang=js"
import style0 from "./config-US.vue?vue&type=style&index=0&id=ec4b4534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports